import React, { useContext } from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react';
import { ChevronDown } from '../../components/ui/Icons';
import ProductContext from '../../contexts/ProductContext';
import { MandatoryVariant, Size } from '../../types/components';

export default function Sizes({
  selectedColor,
  selectedSize,
  selectedMandatoryVariant,
  handleSizeChange,
  handleVariantChange,
  handlePricesChange,
}: {
  selectedColor: string,
  selectedSize: Size,
  selectedMandatoryVariant: MandatoryVariant | null,
  handleSizeChange: (sizes: Size) => void,
  handleVariantChange: (variant: number) => void,
  handlePricesChange: (priceObject: {
    price: string,
    promotionalPrice: string,
    onPromotion: boolean,
  }) => void,
}) {
  const { sizes, translates } = useContext(ProductContext);
  const { products } = translates;

  if (Object.values(sizes[selectedColor]).length > 1) {
    return (
      <Menu as="div" className="filter-dropdow z-50 relative mb-4">
        <MenuButton className="dropdown-opener dropdown-opener-lg btn btn-outline-dark w-full text-lg lg:text-xl leading-none py-4 px-6">
          <span className="flex gap-x-3 items-center flex-1.0 font-normal">
            <span className="font-semibold">{Craft.t(products, 'Maat:')}</span>
            <span>{selectedSize.size}</span>
          </span>
          <ChevronDown />
        </MenuButton>
        <MenuItems
          modal={false}
          className="absolute max-h-60 overflow-x-hidden overflow-y-auto bg-white top-full left-0 min-w-full w-max max-w-72 py-1 lg:pr-6 gap-y-2.5 shadow-md rounded"
        >
          <ul>
            {Object.values(sizes[selectedColor]).map((size) => (
              <MenuItem as="li" key={size.size} className="group">
                <button
                  type="button"
                  className={`w-full px-6 py-2 text-left text-lg lg:text-xl leading-normal underline decoration-1 decoration-transparent transition-all hover:decoration-current group-has-[.active]:text-accent${selectedSize.id === size.id ? ' active' : ''}`}
                  onClick={() => {
                    handleSizeChange(size);
                    handleVariantChange(size.id);
                    handlePricesChange({
                      price: size.price
                        + (selectedMandatoryVariant !== null ? selectedMandatoryVariant.price : 0),
                      promotionalPrice: size.promotionalPrice
                        + (selectedMandatoryVariant !== null ? selectedMandatoryVariant.price : 0),
                      onPromotion: size.onPromotion,
                    });
                  }}
                >
                  {size.size}
                </button>
              </MenuItem>
            ))}
          </ul>
        </MenuItems>
      </Menu>
    );
  }

  if (selectedSize.size) {
    return (
      <div className="filter-dropdown z-50 relative mb-4">
        <span className="flex gap-x-3 items-center flex-1.0 font-normal">
          <span className="font-semibold">{Craft.t('product', 'Maat:')}</span>
          <span>{selectedSize.size}</span>
        </span>
      </div>
    );
  }

  return null;
}
